import * as React from 'react';
import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import Badge from '@mui/material/Badge';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { DayCalendarSkeleton } from '@mui/x-date-pickers/DayCalendarSkeleton';
import { SERVER_URL } from '../constants';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Box } from '@mui/material';

const initialValue = dayjs();

function ServerDay(props) {
  const { highlightedDays = [], day, outsideCurrentMonth, onDayClick, ...other } = props;

  const matchedSchedule = highlightedDays.find((highlightedDay) =>
    day.isSame(highlightedDay.date, 'day')
  );

  const isSelected = !outsideCurrentMonth && Boolean(matchedSchedule);

  const handleClick = () => {
    if (matchedSchedule) {
      onDayClick(matchedSchedule); // pass the schedule id
    }
  };

  return (
    <Badge
      key={day.toString()}
      overlap="circular"
      badgeContent={
        isSelected ? (
          <AccessTimeIcon sx={{ color: 'darkgrey', fontSize: 18 }} />
        ) : undefined
      }
    >
      <PickersDay
        {...other}
        outsideCurrentMonth={outsideCurrentMonth}
        day={day}
        onClick={handleClick}
      />
    </Badge>
  );
}

export default function FixedScheduleDatePickerCalendarControl(props) {
  const requestAbortController = React.useRef(null);
  const [highlightedDays, setHighlightedDays] = React.useState([]);

  React.useEffect(() => {
        // store full schedule objects with parsed dayjs
        setHighlightedDays(
        props.schedules.map((item) => ({
            id: item.id,
            date: dayjs(item.date),
        }))
        );
        return () => requestAbortController.current?.abort();
    }, [props.schedules]);

    const shouldDisableDate = (date) => {
        // Disable all dates that are not in highlightedDates
        return !highlightedDays.some((d) => d.date.isSame(date, 'day'));
    };


  const handleDayClick = (selectedSchedule) => {
    console.log('User clicked schedule with ID:', selectedSchedule.id);
    props.setSelectedDate(selectedSchedule.date);
    props.setSelectedScheduleId(selectedSchedule.id);
    props.setOpenTimePicker(true);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateCalendar
        sx={{ width: '100%', overflowX: 'hidden', mx: 'auto' }}
        defaultValue={initialValue}
        onMonthChange={() => {}}
        slots={{ day: ServerDay }}
        slotProps={{
          day: {
            highlightedDays,
            onDayClick: handleDayClick,
          },
        }}
        shouldDisableDate={shouldDisableDate}
      />
    </LocalizationProvider>
  );
}